import CompareShareholders1099Misc from './CompareShareholders1099Misc';

export default CompareShareholders1099Misc;
